// app/javascript/controllers/dynamic_links_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  addLink(event) {
    event.preventDefault()
    
    const linkInput = document.createElement('input')
    linkInput.type = 'url'
    linkInput.name = 'project[form_data][other_links][]'
    linkInput.placeholder = 'https://...'
    linkInput.className = 'w-full bg-zinc-800 border border-zinc-700 rounded-lg px-4 py-2.5 text-white placeholder-zinc-500 focus:outline-none focus:border-emerald-500'
    
    this.containerTarget.appendChild(linkInput)
  }
}
